import Resource from './common/resource';

class CustomReports extends Resource {
  path = 'custom-reports';
}

export default CustomReports;
